(() => {
  function init() {
    const root = document.querySelector('[data-mm-pack]');
    if (!root || root.dataset.ready) return;
    const form = root.closest('form');
    const originalModel = form.querySelector('#productSelect-option-0');
    const originalPack = form.querySelector('#productSelect-option-1');
    const master = form.querySelector('#productSelect');
    if (!originalModel || !originalPack || !master) return;
    const data = JSON.parse(root.querySelector('[data-pack-data]').textContent);
    const text = data.strings;
    const money = value => new Intl.NumberFormat('en-IE', {style:'currency', currency:data.currency}).format(value / 100);
    const model = root.querySelector('select');
    const cards = [...root.querySelectorAll('.mm-pack__card')];
    const inputs = cards.map(card => card.querySelector('input'));
    let chosen = data.variants.find(v => String(v.id) === master.value);
    if (!chosen) return;
    let pack = chosen.pack;
    model.value = chosen.model;
    const variant = count => data.variants.find(v => v.model === model.value && v.pack === count);
    function render() {
      cards.forEach((card, index) => {
        const v = variant(String(index + 1));
        const input = inputs[index];
        input.checked = pack === input.value;
        input.disabled = !v || !v.available;
        card.classList.toggle('is-disabled', input.disabled);
        card.querySelector('[data-pack-price]').textContent = v ? money(v.price) : '—';
        card.querySelector('[data-pack-unit]').textContent = v ? money(v.price / (index + 1)) + ' ' + text.each : '';
        card.querySelector('[data-pack-availability]').textContent = !v ? text.unavailable : !v.available ? text.sold_out : '';
      });
      const one = variant('1');
      const two = variant('2');
      const saving = root.querySelector('[data-pack-saving]');
      saving.hidden = !(one && two && one.available && two.available && two.price < one.price * 2 && two.price >= one.price);
      saving.replaceChildren();
      if (!saving.hidden) {
        const strong = document.createElement('strong');
        strong.textContent = text.extra.replace('{amount}', money(two.price - one.price));
        const detail = document.createElement('span');
        detail.textContent = text.save.replace('{amount}', money(one.price * 2 - two.price));
        saving.append(strong, detail);
      }
      chosen = variant(pack);
      root.querySelector('[data-pack-summary]').textContent = chosen ? text.summary.replace('{model}', chosen.model).replace('{pack}', chosen.pack).replace('{price}', money(chosen.price)) : text.unavailable;
      const qty = form.querySelector('#Quantity');
      if (qty && chosen) {
        qty.max = chosen.maximum;
        if (chosen.available && Number(qty.value) > chosen.maximum) qty.value = Math.max(1, chosen.maximum);
      }
    }
    function commit() {
      originalModel.value = model.value;
      originalPack.value = pack;
      originalPack.dispatchEvent(new Event('change', {bubbles:true}));
      render();
    }
    model.addEventListener('change', () => {
      if (!variant(pack)?.available) {
        const available = data.variants.find(v => v.model === model.value && v.available);
        pack = available ? available.pack : (variant(pack) ? pack : '1');
      }
      commit();
    });
    inputs.forEach(input => input.addEventListener('change', () => {pack = input.value; commit();}));
    root.dataset.ready = 'true';
    root.hidden = false;
    form.classList.add('mm-pack-form');
    root.closest('[data-type="product-template"]').classList.add('mm-glass-product');
    document.body.classList.add('mm-glass-page');
    const quantityLabel = form.querySelector('.group-quantity > .control-label');
    if (quantityLabel) quantityLabel.textContent = text.quantity;
    const qty = form.querySelector('#Quantity');
    if (qty) qty.setAttribute('aria-label', text.quantity);
    render();
  }
  if (window.jQuery) window.jQuery(init);
  else if (document.readyState === 'complete') init();
  else window.addEventListener('load', init, {once:true});
  document.addEventListener('shopify:section:load', init);
})();
